/** Session flag for static admin UI login (see ProtectedRoute). */
export const UC_ADMIN_SESSION_KEY = "uc_admin_session";
